import { createContext } from 'react';

import Slideshow from './Slideshow';
import { SlideshowContent } from '../types/Slideshow';
import { getSlideshow } from '../utils/slideshowContent';

interface SlideshowContextProps {
  currSlug: string;
  content: SlideshowContent;
}

export const SlideshowContext = createContext<SlideshowContextProps | null>(null);

const Quiz = () => {
  const path = window.location.pathname;
  const slideshow = getSlideshow();

  return (
    <SlideshowContext.Provider value={{ currSlug: path, content: slideshow }}>
      <div className="text-left">
        <Slideshow />
      </div>
    </SlideshowContext.Provider>
  );
};

export default Quiz;
